import axios from "axios"
import { FIRMFLOWURL } from "./url";
export const loginToAccount = (form) => {
    return new Promise(async resolve => {
        try {
            console.log(process.env.FIRMFLOWURL);
            const encodedEmail = encodeURIComponent(form.email);
            const encodedPassword = encodeURIComponent(form.password);
            const response = await axios.post(`${FIRMFLOWURL}api/Auth/LogIn?email=${encodedEmail}&password=${encodedPassword}`)
            resolve({...response, success: true});
        }catch(err){
            console.log(err)
            const backendMessage =
                err?.response?.data?.message ||
                err?.response?.data ||
                'Email or password incorrect!';
            resolve({
                success: false,
                message:
                    typeof backendMessage === "string"
                        ? backendMessage
                        : 'Email or password incorrect!',
            });
        }
    })
}
